import EmailAddress from "common/values/email-address/email-address";
import Name, { NameJSON } from "common/values/name/name";
import Password from "common/values/password/password";

export interface RegistrationInfoJSON {
  name: NameJSON;
  emailAddress: string;
  password?: string;
}

export default class RegistrationInfo {
  name: Name;
  email: EmailAddress;
  password?: Password;

  constructor(name: Name, email: EmailAddress, password?: Password) {
    this.name = name;
    this.email = email;
    this.password = password;
  }

  public toJSON(): RegistrationInfoJSON {
    return {
      name: this.name.toJSON(),
      emailAddress: this.email.toString(),
      password: this.password?.toString()
    }
  }

  public static fromJSON(json: RegistrationInfoJSON): RegistrationInfo {
    return new RegistrationInfo(
      Name.fromJSON(json.name),
      EmailAddress.fromJSON(json.emailAddress),
      json.password ? Password.fromJSON(json.password) : undefined
    );
  }
}

export class InvalidRegistrationInfoError extends Error {
  issues: unknown;

  constructor(issues: unknown) {
    super(`Invalid registration info.`);
    this.issues = issues;
  }
}
